import {getAuth} from '@jobseeker/common-core/utils';
const authHeader = () => {
  if (typeof window !== 'undefined') {
    const auth = getAuth();
    if (auth?.token) {
      return {Authorization: 'Bearer ' + auth.token};
    } else {
      return {};
    }
  }

  return {};
};

export default authHeader;
